/**
 * There will be one reducer file per page / common component
 */
import {
    GET_PAGEVISIBILITYRULE_SUCCESS,
    GET_PAGEVISIBILITYRULE_FAILURE,
    GET_PAGEVISIBILITYRULE,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
    pageRuleList: [],
    statusCode: '',
    statusMessage: '',
    pageRuleListLoader: false,
};

const PageVisibilityRuleReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PAGEVISIBILITYRULE:
            return {
                ...state,
                pageRuleListLoader: true,
            };
        case GET_PAGEVISIBILITYRULE_SUCCESS:
            return {
                ...state,
                ...action.data,
                pageRuleListLoader: false,
            };
        case GET_PAGEVISIBILITYRULE_FAILURE:
            return {
                ...state,
                pageRuleListLoader: false,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'pageVisibilityKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    PageVisibilityRuleReducer
);
